import { render, staticRenderFns } from "./submissions_over_time_graph.vue?vue&type=template&id=1140c1c5&scoped=true&"
import script from "./submissions_over_time_graph.vue?vue&type=script&lang=ts&"
export * from "./submissions_over_time_graph.vue?vue&type=script&lang=ts&"
import style0 from "./submissions_over_time_graph.vue?vue&type=style&index=0&id=1140c1c5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140c1c5",
  null
  
)

export default component.exports